import { useAppContext } from "@web/route-services/root/AppContext";
import { useEffect } from "react";

interface Props {
  titleRef: React.RefObject<HTMLDivElement>;
  isFetching: boolean;
}

/**
 * A hook that focuses the explore title when the page is loaded.
 */
export function useFocusExploreTitle({ titleRef, isFetching }: Props) {
  const { isDesktopScreen, doFocusExploreRef } = useAppContext();
  useEffect(() => {
    const doFocus = doFocusExploreRef.current;
    if (!doFocus) return;
    if (isFetching) return;

    if (titleRef?.current) {
      if (isDesktopScreen) {
        titleRef.current.scrollIntoView({ behavior: "smooth" });
        return;
      } else {
        // On mobile, we need to calculate the y offset to make room for the floating header bar
        const headerHeight = isDesktopScreen ? 0 : 60;
        const elementPosition = titleRef.current.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
      doFocusExploreRef.current = false;
    }
  }, [doFocusExploreRef, isDesktopScreen, isFetching, titleRef]);
}
